import initialState from './state.js'

const FETCH_UPDATED = (state, data) => {
  state.survey = data.data.survey;
}

const RESET_STATE = (state) => {
  let iState = initialState.get();
  //Preserve fetching state
  state.completed = null;
  iState.api.get.fetching = state.api.get.fetching;
  Object.assign(state, initialState);
}

const SURVEY_ANSWERING = (state, value) => {
	state.api.post.answer.sending = !!value;
}

const FETCHING = (state, value) => {
  state.api.get.fetching = !!value;
}

const SURVEY_USER_STATE = (state, data) => {
  state.survey.completed = data.completed;
  state.survey.canComplete = data.canComplete;
  state.survey.calendarId = data.calendar_id
}

export default {
  FETCH_UPDATED,
  FETCHING,
  RESET_STATE,
  SURVEY_ANSWERING,
  SURVEY_USER_STATE
};
